import { Check, Circle } from 'lucide-react';
import { PASSWORD_REQUIREMENTS, validatePassword } from '@/lib/passwordValidation';

interface PasswordRequirementsProps {
  password: string;
}

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const { checks } = validatePassword(password);

  return (
    <div className="space-y-1.5 text-sm">
      <p className="text-muted-foreground font-medium">Password requirements:</p>
      <ul className="space-y-1">
        {PASSWORD_REQUIREMENTS.map((req) => {
          const isMet = checks[req.key as keyof typeof checks];
          return (
            <li
              key={req.key}
              className={`flex items-center gap-2 transition-colors ${
                isMet ? 'text-green-500' : 'text-muted-foreground'
              }`}
            >
              {isMet ? (
                <Check className="w-3.5 h-3.5" />
              ) : (
                <Circle className="w-3.5 h-3.5" />
              )}
              <span>{req.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
